export const FAQ_CATEGORIES = [
  "All",
  "Getting Started",
  "Buying and Selling",
  "Security and Storage",
  "Delivery",
] as const;

export type FaqCategory = (typeof FAQ_CATEGORIES)[number];

type QuestionCategory = Exclude<FaqCategory, "All">;

export type FaqQuestion = {
  category: QuestionCategory;
  question: string;
  answer: string;
};

export const FAQ_QUESTIONS: FaqQuestion[] = [
  {
    category: "Security and Storage",
    question: "Is my gold real and physically backed?",
    answer:
      "Yes. Every gram you buy is allocated 24K physical gold, held in an insured Dubai vault under your name by Loomis International and independently audited. You can take physical delivery at any time.",
  },
  {
    category: "Getting Started",
    question: "Is there a minimum commitment?",
    answer:
      "No. Start from AED 10, add whenever you like, sell whenever you need. No monthly commitment, no penalty.",
  },
  {
    category: "Buying and Selling",
    question: "Are there any fees to buy, hold or sell?",
    answer:
      "No subscription and no storage fee. Our margin sits inside the buy-sell spread and every order shows the full breakdown before you confirm. Physical delivery carries a minting and courier charge, also shown up front.",
  },
  {
    category: "Security and Storage",
    question: "What happens to my gold if JustGold stops operating?",
    answer:
      "Your gold is allocated to you and held by Loomis International as custodian, separate from company assets. It is your property, not ours.",
  },
  {
    category: "Security and Storage",
    question: "Is JustGold Shariah compliant?",
    answer:
      "Yes. Independently reviewed and certified by Panacea Consulting, Bahrain. Every purchase is backed by real physical gold and silver, with no interest and no lending against your holding. See our Shariah compliance page.",
  },
  {
    category: "Buying and Selling",
    question: "How quickly can I sell my gold and get paid?",
    answer:
      "You can sell gold anytime after 24 hours from the time of purchase from the app at the live selling price. The app shows the complete order details before you confirm the sale.",
  },
  {
    category: "Buying and Selling",
    question: "How are gold prices set in the app?",
    answer:
      "Prices on JustGold are linked to live international gold and silver market rates. The final transaction price is clearly shown before you confirm your purchase.",
  },
  {
    category: "Delivery",
    question: "Can I take physical delivery of my gold?",
    answer:
      "Yes. You can redeem gold and silver through the app. Available products, delivery details, and any applicable charges are shown before confirmation in the Delivery section of the app.",
  },
];
